export enum SearchType {
  MAP,
  LIST,
}
